module.exports = __webpack_public_path__ + "img/white-x.c2978f26.svg";